import { Macro } from './Macro'

export interface IPublisher {
    id?: number
    deleted?: boolean
    name?: string
    url?: string
    macros?: Macro[]
}

export class Publisher implements IPublisher {
    id: number;
    dateCreated: Date;
    deleted: boolean;
    dateDeleted: Date;
    name: string;
    url: string;
    macros: Macro[];

    constructor()
    constructor(obj: IPublisher)
    constructor(obj?: IPublisher) {
        this.id = obj && obj.id || undefined;
        this.deleted = obj && obj.deleted || false;
        this.name = obj && obj.name || undefined;
        this.url = obj && obj.url || undefined;
        this.macros = obj && obj.macros || [];
    }
}
